var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDevOpsAccelerated(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 58,
    height: 58,
    viewBox: "0 0 58 58",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M51.3542 17.8241C51.3542 20.7884 50.1766 23.6313 48.0805 25.7274C45.9844 27.8236 43.1414 29.0011 40.1771 29.0011C37.2127 29.0011 34.3698 27.8236 32.2737 25.7274C30.1776 23.6313 29 20.7884 29 17.8241C29 14.8597 30.1776 12.0168 32.2737 9.92067C34.3698 7.82456 37.2127 6.64697 40.1771 6.64697C43.1414 6.64697 45.9844 7.82456 48.0805 9.92067C50.1766 12.0168 51.3542 14.8597 51.3542 17.8241Z",
    stroke: "#D41E4D",
    strokeWidth: 3
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M40.1748 12.2344V17.8229H45.7633",
    stroke: "#D41E4D",
    strokeWidth: 3
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M4.40918 51.3563H27.8811L49.1175 44.65V43.7738C49.1167 42.8617 48.902 41.9625 48.4908 41.1484C48.0796 40.3344 47.4832 39.628 46.7496 39.0861C46.016 38.5442 45.1655 38.1818 44.2665 38.0281C43.3675 37.8744 42.445 37.9335 41.573 38.2009L27.8811 42.4146M27.8811 42.4146H16.704M27.8811 42.4146V35.7084L13.8203 33.5445C12.8636 33.3972 11.8864 33.4585 10.9557 33.7243C10.025 33.99 9.16269 34.4539 8.42803 35.0841C7.69336 35.7143 7.10366 36.4959 6.69937 37.3753C6.29508 38.2548 6.08575 39.2113 6.08574 40.1792",
    stroke: "#D41E4D",
    strokeWidth: 3
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDevOpsAccelerated);
export default __webpack_public_path__ + "static/media/DevOps_Accelerated.8638b979b1ff9f4ccc9cfd8b3c6a383a.svg";
export { ForwardRef as ReactComponent };